"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilModuleResolution = exports.hilModuleResolutionDtoSchema = exports.HilModuleResolutionType = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
Object.defineProperty(exports, "HilModuleResolutionType", { enumerable: true, get: function () { return cadstrom_shared_1.HilModuleResolutionType; } });
const hil_sigma_model_resolution_properties_js_1 = require("./hil-sigma-model-resolution-properties.js");
const hil_package_store_resolution_properties_js_1 = require("./hil-package-store-resolution-properties.js");
const merge_values_js_1 = require("../utils/merge-values.js");
const hilModuleResolutionSchema = z.object({
    id: z.string().default(() => (0, cadstrom_shared_1.generateCadstromUid)(cadstrom_shared_1.CadstromObjectType.BomItem)),
    isReviewed: z.boolean().default(false),
    moduleRef: z.string(),
    isDnp: z.boolean().default(false),
    moduleDatasheetUrl: z.string().nullable().default(null),
    moduleDatasheetFileId: z.string().nullable().default(null),
    resolutionType: z.nativeEnum(cadstrom_shared_1.HilModuleResolutionType).default(cadstrom_shared_1.HilModuleResolutionType.SigmaModel),
    sigmaModelResolutionProperties: hil_sigma_model_resolution_properties_js_1.HilSigmaModelResolutionProperties.schema.prefault({}),
    packageStoreResolutionProperties: hil_package_store_resolution_properties_js_1.HilPackageStoreResolutionProperties.schema.prefault({}),
});
exports.hilModuleResolutionDtoSchema = z.object({
    isReviewed: z.boolean().optional(),
    isDnp: z.boolean().optional(),
    resolutionType: z.nativeEnum(cadstrom_shared_1.HilModuleResolutionType).optional(),
    sigmaModelResolutionProperties: hil_sigma_model_resolution_properties_js_1.HilSigmaModelResolutionProperties.dtoSchema.optional(),
    packageStoreResolutionProperties: hil_package_store_resolution_properties_js_1.HilPackageStoreResolutionProperties.dtoSchema.optional(),
});
exports.HilModuleResolution = {
    create: (input) => {
        return hilModuleResolutionSchema.parse(input);
    },
    merge: (existing, incoming) => ({
        id: existing.id,
        isReviewed: (0, merge_values_js_1.mergeValues)(existing.isReviewed, incoming.isReviewed),
        moduleRef: existing.moduleRef,
        moduleDatasheetUrl: existing.moduleDatasheetUrl,
        moduleDatasheetFileId: existing.moduleDatasheetFileId,
        isDnp: (0, merge_values_js_1.mergeValues)(existing.isDnp, incoming.isDnp),
        resolutionType: (0, merge_values_js_1.mergeValues)(existing.resolutionType, incoming.resolutionType),
        sigmaModelResolutionProperties: (0, merge_values_js_1.mergeValues)(existing.sigmaModelResolutionProperties, incoming.sigmaModelResolutionProperties, hil_sigma_model_resolution_properties_js_1.HilSigmaModelResolutionProperties.merge),
        packageStoreResolutionProperties: (0, merge_values_js_1.mergeValues)(existing.packageStoreResolutionProperties, incoming.packageStoreResolutionProperties, hil_package_store_resolution_properties_js_1.HilPackageStoreResolutionProperties.merge),
    }),
    schema: hilModuleResolutionSchema,
    dtoSchema: exports.hilModuleResolutionDtoSchema,
};
//# sourceMappingURL=hil-module-resolution.js.map